export default function MenuItem() {
  return {
    MuiMenuItem: {},
  };
}
